module.exports = __webpack_public_path__ + "static/images/my.2ejyFx1.svg";